// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UOG7","colBig":"styles_colBig__2IRhd","colSmall":"styles_colSmall__X8lO1","shopifyNameWrapper":"styles_shopifyNameWrapper__2oFJD"};